export class ShoppingCartService {


    constructor () {
        this._shoppingCart = {};
        this._loading = false;
        this._hashKey = 'alfana-shopping-cart-id';
    }

    get () {
        return this._shoppingCart;
    }

    set (cart) {
        this._shoppingCart = cart;
        bus.$emit('shopping-cart-changed', cart);
    }

    reload () {
        this.getByHash(hash);
    }

    getItems()
    {
        if(typeof this.get().items !== 'undefined') {
            return this.get().items;
        }
        return {};
    }

    getItemsHtml()
    {
        axios.get('/shopping_carts/items/html')
            .then(response => {
                this._loading = false;
                bus.$emit('shopping-cart-items-html-loaded', response.data);
            });
    }

    getItem(rowId) {
        let items = this.getItems();

        if (typeof items[rowId] !== 'undefined') {
            return items[rowId];
        }
        return null;
    }

    getItemBySku(sku) {
        let items = this.getItems();
        for (let key in items) {
            let item = items[key];

            if (parseInt(item.id) === parseInt(sku)) {
                return item;
            }
        }

        return null;
    }

    getCount()
    {
        return this.get().count;
    }

    getHashKey()
    {
        return this._hashKey;
    }

    /**
     * Get all of the authorized tokens for the user.
     */
    getByHash(hash) {
        let self = this;
        if(self._loading === false) {
            self._loading = true;
            axios.get('/shopping_carts/hash/' + hash)
                .then(response => {
                    this.set(response.data);
                }).finally(function () {
                    self._loading = false;
                });
        }
    }

    /**
     * Get all of the authorized tokens for the user.
     */
    addToCart(sku, qty, hash, action) {
        action = action || 'add';

        let route = '/shopping_carts/add/'+ sku + '/' + qty;
        if(hash) {
            route = route + '/' + hash;
        }

        route += '?action='+ action;

        bus.$emit('shopping-cart-item:add:start', sku, qty, hash);


        axios.post(route)
            .then(response => {
                if(typeof response.data.cart !== 'undefined') {
                    this.set(response.data.cart);
                    this.getItemsHtml();
                }
                bus.$emit('shopping-cart-item:add:end', sku, response.data);
            });

    }

}